export const getPersonalPropertyProgramOptions = () => {
  const options = [
    "ITGBL",
    "DPS",
    "DOS",
    "DPM",
    "TOS",
    "DEPLO",
    "LIFTV",
    "COMM",
    "DOSTR",
    "GSA",
    "GSAPA",
    "LOCMO",
    "S&RTS",
  ];

  return options.map((option) => ({ value: option, label: option }));
};
